module.exports = __webpack_public_path__ + "img/kt-right.25734340.png";